module.exports = __webpack_public_path__ + "assets/icon-lock-blue.fb6204d1.svg";